let getFlagImageName = function(lang){
  if (!lang) return 'default-flag';
  switch(lang.toLowerCase()){
    case'spanish':  return 'spain'; break;
    case'german':  return 'germany'; break;
    case'french':  return 'france'; break;
    case'italian':  return 'italy'; break;
    case'portuguese':  return 'brazil'; break;
    case'russian':  return 'russia'; break;
    default: return 'default-flag'; break;
  }
}
export default getFlagImageName;